export default __webpack_public_path__ + "static/media/gill-sans.5d53acd6.otf";